import React, { useEffect } from "react";
import { getLocationStatusFilterOptions } from "../Locations/Location";
import { Tree, useTreeData, Card } from "@velocity-ehs/component-library";
import { TreeNode } from "../../sharedComponents/tree/PrimeTree";
import { MultiSelect } from "primereact/multiselect";
import StatusTag from "../../sharedComponents/StatusTag";
import { TreeEventNodeEvent } from "primereact/tree";
import classNames from "classnames/bind";
import classes from "../Locations/LocationsTreeCard.module.scss";
import { useTranslation } from "react-i18next";

interface LocationsTreeCardProps {
  statusFilter: any;
  setStatusFilter(value: any): void;
  handleRowClick(e: TreeEventNodeEvent): void;
  handleAddChildLocationClick(parentId: string): void;
}

const LocationsTreeCard = ({
  statusFilter,
  setStatusFilter,
  handleRowClick,
}: LocationsTreeCardProps): React.ReactElement => {
  const treeData = useTreeData();
  const cx = classNames.bind(classes);
  const { t } = useTranslation();
  //This can be uncommented once the ticket or the tree actions menu is ready to be worked on
  // const actionButtons = (nodeId: string): any[] => {
  //   const items = [
  //     {
  //       label: t("location_add_child_location"),
  //       command: () => {
  //         handleAddChildLocationClick(nodeId);
  //       },
  //       show: featureFlags.viewerCanAddChildLocation,
  //     },
  //     {
  //       label: t("universal_Inactivate"),
  //       command: () => {},
  //       show: featureFlags.viewerCanInactivateLocation,
  //     },
  //   ];

  //   return items.filter((item) => item.show);
  // };

  const nodeTemplate = (node: TreeNode, options: any) => {
    return (
      <>
        <span className={cx(options.className, "includeStatus")}>
          <span>{node.label}</span>
          {node.status !== "Active" && (
            <StatusTag
              status={node.status || ""}
              style={{ marginRight: "10px" }}
            />
          )}
        </span>
        {/* <MenuButton
          forceIcon
          items={actionButtons(node.id)}
          icon="pi-ellipsis-h"
          buttonClass="p-button-text"
        /> */}
      </>
    );
  };

  useEffect(() => {
    if (statusFilter.length) {
      treeData.setTreeStatuses([
        "Active",
        ...statusFilter.map((status) => status.id),
      ]);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [statusFilter]);

  const card = (
    <Card
      full
      title={t("universal_Locations")}
      headerAction={
        <MultiSelect
          value={statusFilter}
          options={getLocationStatusFilterOptions()}
          onChange={setStatusFilter}
          placeholder={t("locations_status_filter")}
        />
      }
    >
      <Tree
        isMultiStatus={statusFilter.length}
        nodeTemplate={nodeTemplate}
        onSelect={handleRowClick}
        hideFooter
      />
      {treeData.isAllFetched && treeData.treeStore.active.tree.length === 0 && (
        <>
          <p className={cx(classes.topInfo)}>
            {t("message_create_location_structure")}
          </p>
          <p>{t("message_physical_locations")}</p>
          <p>
            {t("action_click")}
            <a
              href="https://help.ehs.com/knowledge-base/understanding-locations-location-groups-and-location-attributes/"
              target="_blank"
              rel="noreferrer"
              className={cx(classes.clickHere)}
            >
              {t("interface_here")}
            </a>
            {t("message_for_more_information")}
          </p>
        </>
      )}
    </Card>
  );

  return card;
};

export { LocationsTreeCard };
